import {announce} from '@github-ui/aria-live'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import {LABELS} from '../constants'
import {useSavedViewEndpoints} from '../contexts/SavedViewEndpointsContext'
import type {CreateSavedViewResponse, DuplicateSavedViewVariables} from '../types'
import {
  primeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutationJson,
} from '../utils/saved-view-mutations'

export function useDuplicateSavedViewMutation({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()
  const {basePath} = useSavedViewEndpoints(owner, repo)

  return useMutation<CreateSavedViewResponse, Error, DuplicateSavedViewVariables>({
    mutationFn: ({view, name}) =>
      sendSavedViewMutationJson<CreateSavedViewResponse>(
        `${basePath}.json`,
        {
          method: 'POST',
          body: {
            name,
            query: view.query,
            description: view.description ?? undefined,
            icon: view.icon,
            color: view.color,
            source: 'duplicate',
            visibility: view.visibility,
          },
        },
        LABELS.views.duplicateError,
      ),
    onSuccess: ({savedView}) => primeSavedViewCaches({queryClient, owner, repo}, savedView),
    onError: () => announce(LABELS.views.duplicateError, {assertive: true}),
  })
}
